import { initHeroAnimations } from './animations/hero-animations.js';
import { initScrollAnimations } from './animations/scroll-animations.js';
import LenisController from './utils/lenis-config.js';

class App {
  constructor() {
    this.lenis = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.onDOMReady());
    } else {
      this.onDOMReady();
    }
  }

  onDOMReady() {
    console.log('🚀 Initializing GSAP animations...');
    
    // this.initLenis();
    this.initAnimations();
    this.initExistingFeatures();
  }

  initLenis() {
    this.lenis = new LenisController({
      duration: 1.5,
      mouseMultiplier: 0.8,
      touchMultiplier: 1.2
    });

    this.lenis.on('scroll', (e) => {
      const progress = e.progress;
      document.documentElement.style.setProperty('--scroll-progress', progress);
    });
  }

  initAnimations() {
    // Initialize hero animations after Lenis is ready
    setTimeout(() => {
      initHeroAnimations();
    }, 100);
    
    setTimeout(() => {
      initScrollAnimations();
    }, 500);
    
    console.log('✅ All animations initialized');
  }

  initExistingFeatures() {
    this.initMobileMenu();
    this.initProductSubmenu();
    this.initTabSwitcher();
  }

  initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobile-menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (mobileMenuBtn && mobileMenu) {
      mobileMenuBtn.addEventListener('click', function() {
        mobileMenu.classList.toggle('hidden');
        
        const svg = mobileMenuBtn.querySelector('svg');
        const isOpen = !mobileMenu.classList.contains('hidden');
        
        if (isOpen) {
          svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>';
        } else {
          svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>';
        }
      });
      
      const mobileLinks = mobileMenu.querySelectorAll('a[href^="#"]');
      mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
          mobileMenu.classList.add('hidden');
          const svg = mobileMenuBtn.querySelector('svg');
          svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>';
        });
      });
    }
  }

  initProductSubmenu() {
    const productToggle = document.getElementById('product-toggle');
    const productSubmenu = document.getElementById('product-submenu');
    const productArrow = document.getElementById('product-arrow');
    
    if (productToggle && productSubmenu && productArrow) {
      productToggle.addEventListener('click', function() {
        productSubmenu.classList.toggle('hidden');
        
        if (productSubmenu.classList.contains('hidden')) {
          productArrow.style.transform = 'rotate(0deg)';
        } else {
          productArrow.style.transform = 'rotate(180deg)';
        }
      });
    }
  }

  initTabSwitcher() {
    const tabButtons = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
    const tabImages = document.querySelectorAll('.tab-image');
    
    if (tabButtons.length > 0 && tabContents.length > 0) {
      tabButtons.forEach(button => {
        button.addEventListener('click', function() {
          const targetTab = this.getAttribute('data-tab');
          
          // Remove active class from all buttons, contents, and images
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabContents.forEach(content => content.classList.remove('active'));
          tabImages.forEach(image => image.classList.remove('active'));
          
          // Add active class to clicked button
          this.classList.add('active');
          
          // Show target tab content
          const targetContent = document.getElementById(targetTab + '-content');
          if (targetContent) {
            targetContent.classList.add('active');
          }
          
          // Show target tab image
          const targetImage = document.getElementById(targetTab + '-image');
          if (targetImage) {
            targetImage.classList.add('active');
          }
        });
      });
    }
  }

  scrollTo(target, options = {}) {
    if (this.lenis) {
      this.lenis.scrollTo(target, options);
    }
  }

  stopScroll() {
    if (this.lenis) {
      this.lenis.stop();
    }
  }

  startScroll() {
    if (this.lenis) {
      this.lenis.start();
    }
  }
}

const app = new App();
window.app = app;

export default app; 